import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'

/** Nunca lleva una contraseña: solo un token de un solo uso. */
export function InviteLink({token, kind}: {token: string; kind: 'invite' | 'reset'}) {
  const {t} = useTranslation()
  const [copied, setCopied] = useState(false)
  const path = `${kind === 'invite' ? '/claim' : '/reset'}?token=${encodeURIComponent(token)}`
  const href = typeof window !== 'undefined' ? `${window.location.origin}${path}` : path

  async function copy() {
    try {
      await navigator.clipboard.writeText(href)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      setCopied(false)
    }
  }

  return (
    <div className="space-y-2">
      <p className="font-mono text-[10px] font-medium tracking-wider text-muted-foreground uppercase">
        {t(kind === 'invite' ? 'access.claimLinkLabel' : 'access.resetLinkLabel')}
      </p>
      <div className="flex items-center gap-2">
        <a
          href={path}
          data-testid={kind === 'invite' ? 'claim-link' : 'reset-link'}
          className="min-w-0 flex-1 truncate rounded-lg bg-secondary/60 px-2.5 py-1.5 font-mono text-xs text-foreground hover:underline">
          {href}
        </a>
        <Button type="button" size="sm" variant="outline" onClick={copy}>
          {copied ? t('access.copied') : t('access.copyLink')}
        </Button>
      </div>
    </div>
  )
}
